var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{ 'h-100': _vm.isloggedin },attrs:{"id":"app"}},[_c('Navbar'),(_vm.isloggedin)?_c('LoggedInContent'):_c('LoggedOutContent')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }